import { useEffect, useState } from "react";

/** Live width of an element (ResizeObserver) – used to decide how many surfaces fit side by side. */
export function useElementWidth(ref) {
  const [w, setW] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver((entries) => { for (const e of entries) setW(Math.round(e.contentRect.width)); });
    ro.observe(el);
    setW(Math.round(el.getBoundingClientRect().width));
    return () => ro.disconnect();
  }, [ref]);
  return w;
}
